import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getApprovalFlowScreen } from '@ebalance/proto/bffuser/v1/approval_flow_service-ApprovalFlowService_connectquery'
import {
  GetApprovalFlowScreenRequestSchema,
  type GetApprovalFlowScreenResponse,
} from '@ebalance/proto/bffuser/v1/approval_flow_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 承認フロー管理画面のロードに必要なデータ (全プロセス設定 + 承認者候補) を
 * BFF の 1 リクエストで取得する。BFF が backend の承認フロー設定取得と
 * メンバー一覧取得を集約して返す。
 *
 * @param options.throwOnError 既定の `ApiClientProvider` は `throwOnError: true`
 *   (= error boundary に飛ばす、 本画面〈承認フロー設定〉のように取得失敗が
 *   そのまま画面の用を為さない場合の既定)。 他画面の一部データとして参照する
 *   呼び出し側 (= 取得失敗時は安全側の既定値にフォールバックしたい) は `false` を
 *   渡す (例: SpotBidding が AC-BSP-015、IntradayBidding が AC-BIN-094 の承認モード解決に使う参照)。
 */
export function useGetApprovalFlowScreen(options?: {
  throwOnError?: boolean
}): UseQueryResult<GetApprovalFlowScreenResponse, ConnectError> {
  return useQuery(
    getApprovalFlowScreen,
    create(GetApprovalFlowScreenRequestSchema, {}),
    // throwOnError は未指定なら key 自体を渡さず QueryClient 既定 (= true) に従う
    // (`throwOnError: undefined` を渡すと既定 true を上書きして error boundary が
    // 無効化されるため、 useListBiddingIntradayOrders と同じ書き方)。
    options?.throwOnError !== undefined
      ? { throwOnError: options.throwOnError }
      : undefined,
  )
}
